<template>
  <div class="cart-wrapper" v-if="currentStep !== 4">
    <div class="cart-container">
      <div class="cart-main">
        <breadcrumb v-if="currentStep !== 0"/>
        <cart-items v-if="currentStep === 0"/>
        <cart-infos v-if="currentStep === 1"/>
        <cart-delivery v-if="currentStep === 2"/>
        <cart-payment v-if="currentStep === 3"/>
      </div>
      <cart-resume/>
    </div>
    <transition name="slide">
      <cart-add v-if="isAdd" :datas="editCard" :isDupplicate="isDupplicate" />
    </transition>
    <transition name="slide">
      <cart-grouped v-if="isGrouped" />
    </transition>
    <transition name="modal">
      <modal v-if="showModal"/>
    </transition>
  </div>
  <cart-confirmation v-else />
</template>
<style lang="scss">
.viewer-element {
  .cart-title {
    @include title(3);
  }
  .cart-limited {
    font-size: rem(12);
    color: $color-error;
    margin-top: rem(20);
    margin-bottom: rem(30);
    max-width: rem(500);
  }
}
.viewer-element {
  .std-form {
    .form-card-help {
      position: absolute;
      right: rem(25);
      top: rem(28);
      transform: translateY(-50%);
      z-index: 2;
      button {
        @include resetBtn;
        width: rem(25);
        height: rem(25);
        line-height: rem(25);
        text-align: center;
        color: $grey-dark;
        font-size: rem(30);
        transition: color $transition-out-hover;
        .ico {
          position: relative;
          top: rem(-3);
          vertical-align: middle;
          line-height: rem(25);
        }
        &:hover, &:focus {
          color: $color-second;
          transition: color $transition-in-hover;
        }
      }
    }
    .radio,
    .checkbox {
      .form-card-help {
        position: relative;
        right: auto;
        top: auto;
        display: inline-block;
        transform: none;
        button {
          vertical-align: middle;
        }
      }
    }
    .form-help {
      display: inline-block;
      font-size: rem(14);
      color: $grey;
      & + .form-card-help {
        margin-left: rem(5);
      }
    }
  }
  .cart-radio {
    position: relative;
    display: block;
    &:hover {
      .cart-resume-disable {
        @include visible;
      }
    }
    [type=radio] {
      @include hideAccess;
    }
    .cart-radio-wrapper.is-checked,
    [type=radio]:checked + .cart-radio-wrapper {
      box-shadow: 0 0 0 rem(2) $color-second;
      .cart-radio-value {
        color: $color-second;
      }
      &::before {
        background-color: $color-second;
        box-shadow: 0 0 0 rem(1) $color-second;
      }
    }
    [type=radio]:disabled + .cart-radio-wrapper {
      opacity: .4;
      cursor: not-allowed;
    }

    .cart-radio-wrapper {
      @include container;
      margin-bottom: rem(10);
      padding: rem(20);
      display: flex;
      align-items: center;
      padding-left: rem(40);
      position: relative;
      cursor: pointer;
      &::before {
        content: '';
        position: absolute;
        top: 50%;
        left: rem(15);
        transform: translateY(-50%);
        width: rem(15);
        height: rem(15);
        background-color: $grey-ulight;
        border: rem(3) solid $grey-ulight;
        box-shadow: 0 0 0 rem(1) $grey;
        border-radius: 100%;
      }
    }
    .cart-radio-content {}
    .cart-radio-title {
      color: $blue-udark;
    }
    .cart-radio-detail {
      font-size: rem(14);
      color: $black;
    }
    .cart-radio-price {
      margin-right: 0;
      margin-left: auto;
      font-size: rem(14);
      color: $black;
      text-align: right;
    }
    .cart-radio-value {
      color: $blue-udark;
      font-size: rem(16);
    }
  }
}
</style>
<style scoped lang="scss">
.cart-wrapper {
  @include wrapper;
  @include vertical-spacing-bottom;
}
.cart-container {
  display: flex;
  @include tablet-max {
    flex-direction: column;
  }
}
.cart-main {
  width: 100%;
  @include tablet-max {
    margin-bottom: rem(40);
  }
  @include desktop {
    width: 70%;
    flex-shrink: 0;
    margin-right: rem(30);
  }
}
.slide-enter-active {
  transition: transform .5s;
}
.slide-leave-active {
  transition: transform .2s;
}
.slide-enter, .slide-leave-to {
  transform: translateX(100%);
}
.modal-enter {
  opacity: 0;
}
.modal-leave-active {
  opacity: 0;
}
.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>
<script>
import { gsap, Power2 } from 'gsap/all';
import AppControlService from '@/services/AppControl';
import UsersService from '@/services/Users';
import ModalService from '@/services/Modal';
import OrdersService from '@/services/Orders';

import Breadcrumb from '@/components/Breadcrumb';
import CartInfos from '@/components/CartInfos';
import CartItems from '@/components/CartItems';
import CartResume from '@/components/CartResume';
import CartDelivery from '@/components/CartDelivery';
import CartPayment from '@/components/CartPayment';
import CartConfirmation from '@/components/CartConfirmation';
import CartAdd from '@/components/CartAdd';
import CartGrouped from '@/components/CartGrouped';
import Modal from '@/components/Modal';

export default {
  name: 'App',
  components: {
    CartAdd,
    CartGrouped,
    Breadcrumb,
    CartResume,
    CartItems,
    CartInfos,
    CartDelivery,
    CartPayment,
    CartConfirmation,
    Modal
  },
  data: () => {
    return {
      isAdd: AppControlService.isOpen,
      isGrouped: AppControlService.isOpenGrouped,
      editCard: null,
      isDupplicate: false,
      showModal: false,
      currentStep: AppControlService.currentStep
    }
  },
  created () {
    UsersService.getCountries();
    ModalService.on('open', () => {
      this.showModal = true;
    });
    ModalService.on('close', () => {
      this.showModal = false;
    });
    AppControlService.on('open-grouped-to-card', (datas) => {
      this.isGrouped = datas.open;
      if(!datas.open) this._scrollToLast();
    });
    AppControlService.on('open-add-to-card', (datas) => {
      this.isAdd = datas.open;
      this.editCard = datas.item;
      this.isDupplicate = datas.dupplicate ? datas.dupplicate : false;
      if(!datas.open) this._scrollToLast();
    });
    AppControlService.on('step', (step) => {
      this.currentStep = step;
      gsap.to(window, {
        duration: .6,
        scrollTo: {
          y: 0
        },
        ease: Power2.easeOut
      });
    });
    document.body.addEventListener('logged', (res) => {
      if(res.detail && AppControlService.currentStep === 0 && !AppControlService.isAuthByStep) {
        window.location.reload();
      }
    });
  },
  mounted () {
    const isLogged = document.querySelector('[data-logged]').dataset.logged === 'true';
    if(isLogged) {
      UsersService.me();
      OrdersService.get();
    }
  },
  methods: {
    _scrollToLast() {
      const cards = [...document.querySelectorAll('.cart-items-list .cart-item.is-card')];
      if (cards.length > 0) {
        const lastCard = cards.at(-1);
        let headerSize = 125;
        if (window.innerWidth >= 1024) headerSize = 105;
        if (window.innerWidth >= 1280) headerSize = 120;
        gsap.to(window, {
          duration: .6,
          scrollTo: {
            y: (window.pageYOffset + lastCard.getBoundingClientRect().top - headerSize),
            autoKill: false
          }
        })
      }
    }
  }
};
</script>
